import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../api/client";
import { getToken } from "../../api/token";

export const ME_QUERY_KEY = ["users", "me"];

// Session bootstrap: GET /auth/me -> { user, role, profile, needsEvaluation }.
export const useMe = (options = {}) =>
  useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: () => apiFetch("/auth/me"),
    enabled: options.enabled ?? Boolean(getToken()),
    staleTime: 60_000,
    retry: false,
  });
